<template>
    <div class="box-shadow box-shadow--big">
        <div class="helper__wrapper">
            <div class="flex-row flex-start">
                <v-checkbox style="display: none"></v-checkbox>

                <v-checkbox
                    class="fake-label row3 custom-input custom-checkbox"
                    color="main-color"
                    type="radio"
                    value="NABRZMIALE"
                    @change="updateProblems"
                    name="right-breast-changes"
                    :label="$t('NABRZMIALE')"
                    v-model="problems"
                >
                </v-checkbox>

                <v-checkbox
                    class="fake-label row3 custom-input custom-checkbox"
                    color="main-color"
                    type="radio"
                    value="WKLESNIECIE"
                    @change="updateProblems"
                    name="right-breast-changes"
                    :label="$t('WKLESNIECIE')"
                    v-model="problems"
                >
                </v-checkbox>

                <v-checkbox
                    class="fake-label row3 custom-input custom-checkbox"
                    color="main-color"
                    type="radio"
                    value="NAPIETA"
                    @change="updateProblems"
                    name="right-breast-changes"
                    :label="$t('NAPIETA')"
                    v-model="problems"
                >
                </v-checkbox>

                <v-checkbox
                    class="fake-label row3 custom-input custom-checkbox"
                    color="main-color"
                    type="radio"
                    value="ZACZERWIENIONA"
                    @change="updateProblems"
                    name="right-breast-changes"
                    :label="$t('ZACZERWIENIONA')"
                    v-model="problems"
                >
                </v-checkbox>

                <v-checkbox
                    class="fake-label row3 custom-input custom-checkbox"
                    color="main-color"
                    type="radio"
                    value="WYDZIELINA"
                    @change="updateProblems"
                    name="right-breast-changes"
                    :label="$t('WYDZIELINA')"
                    v-model="problems"
                >
                </v-checkbox>

                <v-checkbox
                    class="fake-label row3 custom-input custom-checkbox"
                    color="main-color"
                    type="radio"
                    value="WGLEBIENIA"
                    @change="updateProblems"
                    name="right-breast-changes"
                    :label="$t('WGLEBIENIA')"
                    v-model="problems"
                >
                </v-checkbox>

                <v-checkbox
                    class="fake-label row3 custom-input custom-checkbox"
                    color="main-color"
                    type="radio"
                    value="ZYLY"
                    @change="updateProblems"
                    name="right-breast-changes"
                    :label="$t('ZYLY')"
                    v-model="problems"
                >
                </v-checkbox>

                <v-checkbox
                    class="fake-label row3 custom-input custom-checkbox"
                    color="main-color"
                    type="radio"
                    value="SUTKI_WKLESNIETE"
                    @change="updateProblems"
                    name="right-breast-changes"
                    :label="$t('SUTKI_WKLESNIETE')"
                    v-model="problems"
                >
                </v-checkbox>

                <v-checkbox
                    class="fake-label row3 custom-input custom-checkbox"
                    color="main-color"
                    type="radio"
                    value="KSZTALT"
                    @change="updateProblems"
                    name="right-breast-changes"
                    :label="$t('KSZTALT')"
                    v-model="problems"
                >
                </v-checkbox>

                <v-checkbox
                    class="fake-label row3 custom-input custom-checkbox"
                    color="main-color"
                    type="radio"
                    value="POMARANCZOWA"
                    @change="updateProblems"
                    name="right-breast-changes"
                    :label="$t('POMARANCZOWA')"
                    v-model="problems"
                >
                </v-checkbox>

                <div class="flex-column" style="margin-top: -15px">
                    <v-checkbox
                        class="fake-label row3 custom-input custom-checkbox"
                        color="main-color"
                        type="radio"
                        value="INNA"
                        name="right-breast-changes"
                        v-model="problems"
                        :label="$t('OTHER_WHAT')"
                        @change="updateProblems"
                    >
                    </v-checkbox>

                    <input
                        v-if="problems.includes('INNA')"
                        :placeholder="$t('INSERT_CHANGE')"
                        type="text"
                        style="margin-top: -12px"
                        class="el-input__inner el-input__inner--small row3"
                        v-model="problemCustom"
                        @change="updateCustomProblems"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        if (this.$store.getters.survey.section3.q2_1_type_observe) {
            this.problems = this.$store.getters.survey.section3.q2_1_type_observe;
            if (this.problems.includes('INNA')) {
                this.problemCustom = this.$store.getters.survey.section3.q2_1_type_observe_custom;
            }
        } else {
            this.problems = [];
        }
    },
    data() {
        return {
            problems: [],
            problemCustom: '',
        };
    },
    methods: {
        updateProblems() {
            this.$store.commit('STATE_SURVEY', {
                section3: {
                    ...this.$store.getters.survey.section3,
                    q2_1_type_observe: this.problems,
                },
            });
        },
        updateCustomProblems() {
            this.$store.commit('STATE_SURVEY', {
                section3: {
                    ...this.$store.getters.survey.section3,
                    q2_1_type_observe_custom: this.problemCustom,
                },
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// right-breast-changes-observe.vue?3609ab6c